/**
 * 去除所有空格
 * @param {string} str 
 * @returns {string}
 */
export function trimAll(str) {
    if (typeof str === 'string') {
        return str.split(/[\t\r\f\n\s]*/g).join('');

    } else {
        console.error(`${typeof str} is not the expected type, but the string type is expected`)
    }

}

/**
 * 判断元素距离可视区域的高度是否为0
 * @param {documentElement} elem 
 * @returns 
 */
export function getEleRectTop(elem) {
    if (elem instanceof HTMLElement) {
        return elem.getBoundingClientRect().top <= 0;
    } else {
        throw Error('getEleRectTop函数使用错误,请传入dom元素!')
    }
}

export function getScrollbarWidth() {
    const scrollP = document.createElement('p');
    scrollP.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;";
    document.body.appendChild(scrollP);
    const scrollbarWidth = scrollP.offsetWidth - scrollP.clientWidth;
    document.body.removeChild(scrollP);
    return scrollbarWidth;
}

/**
 * 传入两个对象，删除相同的属性并返回新对象
 * @param {*} obj1 
 * @param {*} obj2 
 * @returns 
 */
export function removeMatchingProperties(obj1, obj2, retainKeys = '') {
    // // 获取obj1的所有属性名
    Object.keys(obj1).forEach(key => {
        // 检查obj2是否有相同的属性名且属性值也相同
        if (!retainKeys.includes(key)) {
            if (key in obj2) {
                if (Object.prototype.toString.call(obj2[key]) === '[object Array]' || Object.prototype.toString.call(obj2[key]) === '[object Object]') {
                    if (obj1[key].toString() === obj2[key].toString()) {
                        // 如果属性名和属性值都一致，则从obj1中删除该属性
                        delete obj1[key];
                    }
                } else if (obj1[key] === obj2[key]) {
                    // 如果属性名和属性值都一致，则从obj1中删除该属性
                    delete obj1[key];
                }
            }
        }
    });
    return obj1;
}

/**
 * 递归重设导航校区端
 * @param {*} list 
 * @param {*} sort 
 * @returns 
 */
export function setNavChildren(list, sort = false) {
    if (list.length > 0) {
        if (sort) {
            list.sort((first, last) => {
                return first.userResource.sort - last.userResource.sort
            })
        }
        list.forEach((child) => {
            // child.userResource.viewScope = null
            child = Object.assign(child, child.userResource)
            if (child.children) {
                setNavChildren(child.children, sort)
            }
        })
    }
    return list
}
/**
 * 
 * @returns 判断是否是火狐浏览器
 */
export function isFirefox() {
    return /firefox\/(\d+)/i.test(navigator.userAgent);
}

/**
 * 函数防抖 是n秒后延迟执行，多用于页面scroll滚动，窗口resize，防止按钮重复点击
 * @param {Function} fn 是我们需要包装的事件回调
 * @param {Number} delay 是每次推迟执行的等待时间
 * @returns
 */
export function debounce(fn, delay = 500) {
    // 记录上一次触发的时间
    var timer = null;
    return function () {
        // 保留调用时的this上下文
        var context = this;
        // 保留调用时传入的参数
        var args = arguments;
        // 每次事件被触发时，都去清除上一次延时器
        if (timer) clearTimeout(timer);
        // 设立新的定时器
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    }
}


/**
 * 金额处理
 * @param {*} number 
 * @param {*} decimals 
 * @param {*} dec_point 
 * @param {*} thousands_sep 
 * @returns 
 */
export function toMoney(number, decimals = 2, dec_point, thousands_sep) {
    /*
     * 参数说明：
     * number：要格式化的数字
     * decimals：保留几位小数
     * dec_point：小数点符号
     * thousands_sep：千分位符号
     * */

    number = (number + '').replace(/[^0-9+-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
        dec = typeof dec_point === 'undefined' ? '.' : dec_point,
        s = ''
    // ,toFixedFix = function (n, prec) {
    //     var k = Math.pow(10, prec)
    //     return '' + Math.ceil(n * k) / k
    // }
    s = (prec ? n.toFixed(prec) : '' + Math.round(n)).split('.')
    var re = /(-?\d+)(\d{3})/
    // toFixedFix(n, prec)
    // n.toFixed(prec)
    while (re.test(s[0])) {
        s[0] = s[0].replace(re, '$1' + sep + '$2')
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || ''
        s[1] += new Array(prec - s[1].length + 1).join('0')
    }
    return s.join(dec)
}

/**
 * 获取url参数
 * @param {*} name 
 * @returns 
 */
export function getUrlArg(name = '') {
    if (name === '') return new UrlSearch()
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
    var context = "";
    if (r != null)
        context = decodeURIComponent(r[2]);
    reg = null;
    r = null;
    return context == null || context == "" || context == "undefined" ? "" : context;
}

function UrlSearch() {
    var name, value;
    var str = location.href; //取得整个地址栏
    var num = str.indexOf("?")
    str = str.substr(num + 1); //取得所有参数 stringvar.substr(start [, length ]

    var arr = str.split("&"); //各个参数放到数组里
    for (var i = 0; i < arr.length; i++) {
        num = arr[i].indexOf("=");
        if (num > 0) {
            name = arr[i].substring(0, num);
            value = arr[i].substr(num + 1);
            this[name] = decodeURIComponent(value);
        }
    }
}
// var Request = new UrlSearch(); //实例化  Request所有参数对象集合


export function utilDownloadFile(url, fileName) {
    return new Promise(resolve => {

        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob'; // 设置响应类型为blob

        xhr.onload = () => {
            if (xhr.status === 200) {
                // 创建一个链接元素
                const blob = new Blob([xhr.response]);
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;

                // 兼容性处理，部分浏览器需要手动触发点击事件
                if (document.createEvent) {
                    const event = document.createEvent('MouseEvents');
                    event.initEvent('click', true, true);
                    link.dispatchEvent(event);
                } else {
                    link.click();
                }

                // 下载成功后的处理
                console.log('下载成功');
                resolve(true)
            } else {
                resolve(false);
                // 下载失败后的处理
                console.error('下载失败，状态码：', xhr.status);
            }
        };

        xhr.onerror = () => {
            // 网络错误或其他错误
            console.error('下载出错');
        };

        xhr.send();
    })
}